<div class="modal-top-bar">
    <h3>Detector learning configuration</h3>
</div>
<div class="modal-content nldm-container mb-4" *ngIf="!!selectedConfiguration">
    <div class="d-flex gap-3">
        <div class="nldm-field">
            <span>
                Time limit (hours)
                <mat-icon class="icon-info" title="Total limit, in hours, to stop learning phase.">info</mat-icon>
            </span>
            <input [(ngModel)]="selectedConfiguration.timeLimitHours" type="number" min="0"/>
        </div>
        <div class="nldm-field">
            <span>
                UCL Variation Percentage
            </span>
            <input [(ngModel)]="selectedConfiguration.uclVariationPercentage" type="number"/>
            <span *ngIf="selectedConfiguration !== undefined && !!selectedConfiguration.uclVariationPercentage && selectedConfiguration.uclVariationPercentage < 0.001" class="nldm-error">El porcentaje no puede ser inferior a 0.001%</span>
        </div>
    </div>
</div>
<div class="modal-bottom-bar">
  <button class="button outline mini wide" (click)="dialogRef.close()">Cancel</button>
  <button [disabled]="!selectedConfiguration || !selectedConfiguration.timeLimitHours || !selectedConfiguration.uclVariationPercentage || selectedConfiguration.uclVariationPercentage < 0.001" class="button mini wide" (click)="execute()">Execute</button>
</div>